import { API_BASE_URL } from '../providers/dataProvider';

/**
 * Resolve media URLs for CMS <img> tags.
 * Absolute http(s) URLs pass through; relative paths (e.g. equipment/eq_x.jpg)
 * are prefixed with the API media base.
 */
export function resolveCmsMediaUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  const path = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;
  if (path.startsWith('media/files/')) {
    return `${API_BASE_URL}/${path}`;
  }
  // equipment-images/ legacy prefix → equipment/
  const normalized = path.replace(/^equipment-images\//, 'equipment/');
  return `${API_BASE_URL}/media/files/${normalized}`;
}
